<template>
  <modal-container :id="'addSecurityModal'" small>
    <form @submit.prevent="submit">
      <div class="modal-header">
        <h5 class="modal-title">Add Security</h5>
      </div>
      <div class="modal-body">
        <base-field label="Security">
          <base-input v-model="payload.name" placeholder="name" required />
        </base-field>
        <base-field label="Charge">
          <base-select v-model="payload.charge" placeholder="charge" required source="securityCharges" />
        </base-field>
        <base-field addon-left-icon="pound-sign" label="Amount">
          <base-input v-model="payload.amount" numeric placeholder="amount" required />
        </base-field>
      </div>
      <div class="modal-footer">
        <base-button :loading="saving" primary submit>
          Save
        </base-button>
      </div>
    </form>
  </modal-container>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

import ModalContainer from './ModalContainer.vue'

export default {
  created () {
    this.refresh()
  },

  data: () => ({
    payload: {},
    saving: false
  }),

  name: 'AddSecurityModal',

  components: {
    ModalContainer
  },

  props: {
    noSave: Boolean
  },

  computed: {
    ...mapGetters({
      schema: 'core/securities/schema'
    }),

    ...mapState({
      security: store => store.core.securities.entity
    })
  },

  methods: {
    refresh () {
      this.payload = this.$_.clone(this.schema)
    },

    async submit () {
      const payload = this.$_.clone(this.payload)

      this.saving = true

      if (this.noSave) {
        this.$emit('submitted', payload)
      } else {
        await this.$store.dispatch('core/securities/create', payload)

        this.$emit('saved', this.$_.clone(this.security))
      }

      $('#addSecurityModal').modal('hide')

      this.refresh()

      this.$flash.success('New security added.')

      this.saving = false
    }
  }
}
</script>
